import React from "react";
import { InfoIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { images } from "../../data/content";
const outputs = ["Visual maps", "Decision pathways", "Matrices", "Checklists", "Case exercises", "Goal frameworks", "Practical reference tools"];
export function Creator() {
  return <section className="px-4 py-16 md:py-24" aria-labelledby="creator-title" data-id="element-94" data-mp="1oacukzm0n6bl">
      <div className="mx-auto grid max-w-5xl gap-8 md:grid-cols-[0.9fr_1.1fr] md:items-start md:gap-12" data-id="element-95" data-mp="2bycmw3yz74sa">
        <img src={images.creator} alt="Dr. Elowen Varelli in her therapy office" className="w-full rounded-3xl object-cover md:sticky md:top-8" loading="lazy" data-id="element-96" data-mp="2g0r30gb9fqfv" />
        <div data-id="element-97" data-mp="26yq7pozl7egu">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-brand-600" data-id="element-98" data-mp="26yhx63qxsl8t">About the creator</p>
          <h2 id="creator-title" className="mt-2 font-serif text-[2.1rem] font-black leading-tight text-ink md:text-5xl" data-id="element-99" data-mp="qjyg3ea9mb8l">
            Meet Dr. Elowen Varelli
          </h2>
          <div className="mt-5 space-y-4 text-[16px] leading-relaxed text-muted" data-id="element-100" data-mp="2xh6fx5m56iv0">
            <p data-id="element-101" data-mp="2tf1nubbcduah">
              For years, I watched Occupational Therapists struggle with something that wasn't simply a lack of knowledge.
              They had taken courses, read books, studied sensory systems and knew the terminology.
            </p>
            <p data-id="element-102" data-mp="32haz53efprox">But when a complex child arrived in front of them, the real question remained:</p>
            <p className="font-serif text-2xl font-extrabold leading-snug text-brand-900" data-id="element-103" data-mp="3gd68oimy1qfn">
              “How do I organize everything I'm seeing?”
            </p>
            <p data-id="element-104" data-mp="3q3r8g9ect105">
              That question became the foundation for the Sensory Decision Map™. I created it around a simple idea:{" "}
              <strong className="text-ink" data-id="element-105" data-mp="3l7socy02655j">
                you don't always need more information — sometimes you need a better way to organize the information you
                already have.
              </strong>
            </p>
            <p data-id="element-106" data-mp="61zcxf9grmb8">So I transformed the major components of sensory clinical reasoning into:</p>
          </div>
          <ul className="mt-4 flex flex-wrap gap-2" data-id="element-107" data-mp="b099nuau6uyy">
            {outputs.map(o => <li key={o} className="rounded-full bg-brand-50 px-3.5 py-1.5 text-sm font-semibold text-brand-700" data-id="element-108" data-mp="g05chq7ssgcx">
                {o}
              </li>)}
          </ul>
          <p className="mt-5 text-[16px] leading-relaxed text-muted" data-id="element-109" data-mp="ksew6oibkk6r">
            The result is not another 40-hour course. It's a clinical reasoning companion designed to help you navigate
            complex cases with more structure and clarity.
          </p>
          <p className="mt-5 flex gap-3 rounded-2xl bg-sand p-4 text-sm leading-relaxed text-ink" data-id="element-110" data-mp="yqwjil4bbuo5">
            <InfoIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-600" aria-hidden="true" data-id="element-111" data-mp="13oy274xttrz3" />
            The Sensory Decision Map™ is an educational reasoning tool. It does not replace professional judgment,
            standardized assessments, certification requirements, or appropriate multidisciplinary evaluation.
          </p>
          <div className="mt-8" data-id="element-112" data-mp="2xz4r8urngcfk">
            <CtaButton label="Start organizing my cases" data-id="element-113" data-mp="2t6bogcfqre64" />
          </div>
        </div>
      </div>
    </section>;
}